import React from 'react';

import {observer} from "mobx-react";
import {BettingPromotionModuleButton} from "./betting-promotion.module.button";
import styles from "../styles/betting-promotion.module.scss"
import type {BettingPromotionBookieButtonModel} from "../../../../../core/models/betting-promotion/betting-promotion.bookie-button.model";

export const BettingPromotionModuleButtons = observer(({controller}) => {
  const {state} = controller;
  const {buttons} = state;

  return (
    <div className={styles.buttons}>
      {
        buttons.map((button: BettingPromotionBookieButtonModel, index: Number) => <BettingPromotionModuleButton
          controller={controller}
          button={button}
          key={index}
        />)
      }
    </div>
  );
});